var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"interfaces"},[_c('v-header',{attrs:{"breadcrumb":_vm.links}}),_c('v-table',{attrs:{"columns":_vm.columns,"items":_vm.items,"link":"__link","primary-key-field":"id"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }